<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/qAF1H1/tc-custom/9781680572902.jpg?1705346008608" alt="This image is the cover for the book Triploidy"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Triploidy
      </h1>
      <p class="bookDescription body article font2">
        <b>When their baby is born with a genetic defect caused by an extraterrestrial intelligence, new parents must fight to save their child—and humanity.</b><br/>  <br/> A medical mystery . . . and a threat from beyond the stars.<br/><br/> For Jon and Marianna Knox, the birth of their daughter Persephone marks the happiest day of their lives. Until they learn that Persey is suffering from a rare but fatal condition called “triploidy.”<br/><br/> Her doctors are baffled, and with good reason—because the source of the little girl’s genetic malfunction is not of this Earth. It lies out beyond the orbit of Saturn.<br/><br/> And it’s coming for all of us.<br/>  <br/> Praise for Bill DeSmedt’s <i>Singularity:</i><br/>  <br/> “A swift, gripping novel with a goose-pimple mix of scary science and near-future action.” —Greg Bear, <i>New York Times</i>–bestselling, Hugo &amp; Nebula Award–winning author of <i>The Unfinished Land</i><br/>  <br/> “An action-packed thriller into perilous realms of black hole physics.” —David Brin, <i>New York Times</i>–bestselling, Hugo &amp; Nebula Award–winning author of <i>Colony High</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Bill DeSmedt
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      WordFire Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5507c114